export enum GenericObjectTypeEnum {
    OBJECT_UNKNOWN = 0,
    OBJECT_REGION = 1,
    OBJECT_LOCATION = 2,
    OBJECT_REGION_MAP = 3,
    OBJECT_INFRASTRUCTURE_STATUS = 4,
    OBJECT_RESTRICTION = 5,
    OBJECT_LETTER_AGREEMENT = 6,
    OBJECT_OPERATION_REQUEST = 7,
    OBJECT_COORDINATION_REQUEST = 8,
    OBJECT_PERFORMANCE_MODEL = 9,
    OBJECT_AUTOPILOT_TRAJECTORY = 10,
    OBJECT_AUTOPILOT_OPERATION = 11,
    OBJECT_AIRSPACEAREA = 12,
    OBJECT_DELIVERY = 13,
    OBJECT_TSEQUENCE = 14,
    OBJECT_COORDINATION_HISTORY = 15,
    OBJECT_LETTER_AGREEMENT_CONTAINER = 16,
    OBJECT_COORDINATION_AGREEMENT_CONTAINER = 17,
    OBJECT_COORDINATION_AGREEMENT = 18,
    OBJECT_TFR_DEFINITION = 19,
    OBJECT_TFR_CONFLICT = 20,
    OBJECT_PUBLIC_SAFETY_COMMUNICATION = 21,
    OBJECT_BASIC_AREA_COMMUNICATION = 22,
    OBJECT_GENERIC_AREA_CONTAINER = 23,
    OBJECT_URBAN_AREA_CONFLICT = 24,
    OBJECT_URBAN_AREA_CONTAINER = 25,
    OBJECT_URBAN_TRACK_NETWORK = 26,
    OBJECT_URBAN_TRACK_SEGMENT = 27,
}

export function toInteger(type: GenericObjectTypeEnum): number {
    return type;
}

export function fromInteger(value: number): GenericObjectTypeEnum {
    if (value in GenericObjectTypeEnum) {
        return value as GenericObjectTypeEnum;
    }
    return GenericObjectTypeEnum.OBJECT_UNKNOWN; // Default to OBJECT_UNKNOWN for invalid values
}
